/**
*
* PendingList
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ListGroup, Modal } from 'react-bootstrap';
import { idValues } from 'utils/arrays.js';
import fixedBottomStyle from 'utils/fixedBottomStyle.js';
import InfiniteScroll from 'components/interaction/InfiniteScroll/index.jsx';
import messages from './messages.js';

function PendingList(props) {
  const { items, onHide, renderItem } = props;
  const style = fixedBottomStyle(120);
  const { loading, hasMore, loadMore } = items;
  const pendingItems = idValues(items);

  return (
    <Modal show onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          <FormattedMessage {...messages.header} />
        </Modal.Title>
      </Modal.Header>
      <InfiniteScroll
        hasMore={hasMore}
        loadMore={loadMore}
        loading={loading}
      >
        <ListGroup className="mb-3" style={style}>
          {pendingItems.map((item) => renderItem(item))}
        </ListGroup>
      </InfiniteScroll>
    </Modal>
  );
}

PendingList.propTypes = {
  onHide: PropTypes.func.isRequired,
  renderItem: PropTypes.func.isRequired,
  fetchOptions: PropTypes.object,
  items: PropTypes.object,
};

export default PendingList;
